import React, { useRef } from "react";
import { cn } from "@/lib/utils";

// Premium neon button with ripple + optional slow pulse.
export const GlowButton = ({
  children,
  variant = "primary",
  className = "",
  pulse = false,
  as = "button",
  ...props
}) => {
  const ref = useRef(null);

  const handleClick = (e) => {
    const el = ref.current;
    if (el) {
      const circle = document.createElement("span");
      const rect = el.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      circle.className = "ripple-span";
      circle.style.width = circle.style.height = `${size}px`;
      circle.style.left = `${e.clientX - rect.left - size / 2}px`;
      circle.style.top = `${e.clientY - rect.top - size / 2}px`;
      el.appendChild(circle);
      setTimeout(() => circle.remove(), 600);
    }
    props.onClick && props.onClick(e);
  };

  const base =
    "relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-[var(--radius-btn)] px-6 py-3 text-sm font-semibold tracking-tight transition-[transform,box-shadow,background-color,border-color] duration-300 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--bg-0)] disabled:opacity-50 disabled:pointer-events-none";

  const variants = {
    primary: cn(
      "bg-[color:var(--neon-g)] text-black hover:brightness-110",
      "shadow-[var(--glow-g)] hover:shadow-[0_0_0_1px_rgba(57,255,20,0.4),0_0_36px_rgba(57,255,20,0.3)]",
      "focus-visible:ring-[color:var(--neon-g)]",
      pulse && "pulse-glow"
    ),
    secondary: cn(
      "glass text-white border border-[rgba(255,255,255,0.12)]",
      "hover:border-[color:var(--stroke-p)] hover:shadow-[var(--glow-p)]",
      "focus-visible:ring-[color:var(--neon-p)]"
    ),
    ghost: cn(
      "rounded-full bg-transparent text-[color:var(--muted)] border border-[rgba(255,255,255,0.12)]",
      "hover:text-white hover:border-[color:var(--stroke-g)] hover:shadow-[var(--glow-g)]",
      "focus-visible:ring-[color:var(--neon-g)]"
    ),
  };

  const Comp = as;
  return (
    <Comp
      ref={ref}
      className={cn(base, variants[variant], className)}
      {...props}
      onClick={handleClick}
    >
      {children}
    </Comp>
  );
};
